function initializeChartbeat(site, section, author) {
   'use strict';
   window._sf_startpt=(new Date()).getTime();
   window._sf_async_config={};
 

   /** CONFIGURATION START **/
   window._sf_async_config.uid = 37612;
   window._sf_async_config.useCanonical = true; 
   window._sf_async_config.domain = site;
   window._sf_async_config.sections = section;
   window._sf_async_config.authors = author;
   /** CONFIGURATION END **/
}

function loadChartbeat(section, author) {
   'use strict';
   var site = location.host;
   if(site == 'localhost' || site.indexOf("dev.cnn.com") >= 0) {
       site = "ref.cnn.com";
   }
   initializeChartbeat(site, section, author);
   window._sf_endpt=(new Date()).getTime();
   var e = document.createElement('script');
   e.setAttribute('src',
       (('https:' === document.location.protocol) ?
         'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/' :
         'http://static.chartbeat.com/') + 'js/chartbeat.js');
       document.body.appendChild(e);

}

function interactivesTwitterIntercept (t_id, t_site)
{
    var tweet = 'http://twitter.com/intent/tweet?url=' + encodeURIComponent(bitly_url) + '&text=' + encodeURIComponent(twitter_description) + '&via=cnn&related=cnnmultimedia';
    var t_bar = cnnsocial.share.data.bars[t_id];
    var t_social = cnnsocial.sites[t_site];

        cnnsocial.share.popup(tweet, t_site, t_social.popwidth, t_social.popheight, t_social.popscroll);
        cnnsocial.share.track({ 'type' : 'click', 'site' : t_site });
}

document.title = document.title + ' - CNN.com';

/* globals CNN_CB, cnnsocial */
/* configure apis to load and specify their callbacks */
cnnsocial.setapiconfig([
    {
        'site' : 'facebook',
        'success' : function() {
            /* trigger connect-cnnsocial.js calls */
            window.cnn_fbAsyncInit();
        }
    },
    { 'site' : 'twitter' }
]);

/* Visual Revenue Reader Response Tracking Script (v6) */
var _vrq = _vrq || [];
var vrId = 6;

	_vrq.push(['id', vrId]);
	_vrq.push(['automate', false]);
	_vrq.push(['track', function(){}]);
(function(d, a){
	var s = d.createElement(a),
	x = d.getElementsByTagName(a)[0];
	s.async = true;
	s.src = 'http://a.visualrevenue.com/vrs.js';
	x.parentNode.insertBefore(s, x);
})(document, 'script');
/* END Visual Revenue Reader Response Tracking Script (v6) */

/* add the multiple config instance for sharebars */
cnnsocial.share.setconfig(cnn_shareconfig);
$j(document).ready(function () {
    'use strict';
    loadChartbeat("{{cnnSectionName}}", "CNN Interactives");

    /* initialize cnnsocial */
    cnnsocial.init();
});
